// extracted by mini-css-extract-plugin
export default {"icon":"wu9WAKcViZW6Z8PMpMDSig=="};